var map = {
	"./academy.svg": 1243,
	"./alcarta.svg": 1968,
	"./alert.svg": 992,
	"./app-picker.svg": 1836,
	"./arrange-2.svg": 7962,
	"./arrange.svg": 5002,
	"./arrow-clockwise.svg": 1575,
	"./arrow-counterclockwise.svg": 4274,
	"./arrow-left-condensed.svg": 9373,
	"./arrow-left.svg": 2867,
	"./arrow-right.svg": 7591,
	"./book.svg": 7465,
	"./bookmark.svg": 6654,
	"./careup.svg": 2986,
	"./checkmark-circle.svg": 922,
	"./checkmark.svg": 2304,
	"./chevron-down.svg": 2625,
	"./chevron-left.svg": 8309,
	"./chevron-right.svg": 5714,
	"./chevron-up.svg": 9970,
	"./clock.svg": 112,
	"./close.svg": 2559,
	"./compose.svg": 9273,
	"./copyright.svg": 9546,
	"./cursor.svg": 7938,
	"./doc.svg": 364,
	"./down.svg": 245,
	"./download.svg": 4390,
	"./email.svg": 2853,
	"./exe.svg": 6844,
	"./expand.svg": 8329,
	"./external.svg": 3852,
	"./facebook.svg": 4734,
	"./file.svg": 1478,
	"./flag.svg": 5327,
	"./folder.svg": 373,
	"./group.svg": 8661,
	"./heart-empty.svg": 3432,
	"./heart-filled.svg": 7533,
	"./info.svg": 8721,
	"./like.svg": 9231,
	"./link.svg": 9977,
	"./linkedin.svg": 3417,
	"./listen.svg": 9880,
	"./lock.svg": 2560,
	"./magnifier-minus.svg": 5275,
	"./magnifier-plus.svg": 8165,
	"./magnifier.svg": 6294,
	"./menu.svg": 5037,
	"./microphone.svg": 6492,
	"./minus.svg": 2438,
	"./music.svg": 8215,
	"./next.svg": 1454,
	"./notification.svg": 5267,
	"./open.svg": 4947,
	"./pause.svg": 5610,
	"./pdf.svg": 7161,
	"./play.svg": 432,
	"./plus.svg": 400,
	"./ppt.svg": 4689,
	"./previous.svg": 7026,
	"./replay.svg": 1688,
	"./results.svg": 9748,
	"./share.svg": 2951,
	"./speaker.svg": 9630,
	"./speechcloud.svg": 5383,
	"./star.svg": 5205,
	"./teacher-options.svg": 263,
	"./timer.svg": 8670,
	"./trashcan.svg": 8580,
	"./twitter.svg": 6204,
	"./unlocked.svg": 6916,
	"./up.svg": 4839,
	"./upload.svg": 9605,
	"./user.svg": 7221,
	"./video.svg": 1607,
	"./view.svg": 5488,
	"./warning.svg": 1085,
	"./whatsapp.svg": 3680,
	"./xls.svg": 8440,
	"./zip.svg": 902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4490;